import { render, staticRenderFns } from "./MultipleStar.vue?vue&type=template&id=55e9df64&scoped=true"
import script from "./MultipleStar.vue?vue&type=script&lang=js"
export * from "./MultipleStar.vue?vue&type=script&lang=js"
import style0 from "./MultipleStar.vue?vue&type=style&index=0&id=55e9df64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e9df64",
  null
  
)

export default component.exports